const paymentMethods = {
  card: 'Secure online payment by Visa, Mastercard or UK debit cards',
  amex: 'Secure online payment by American Express cards',
  cheque: 'UK cheque',
  bankTransfer: 'Bank transfer in GBP (£)',
  other: 'Other',
}

export default paymentMethods
